module.exports = VueClassComponent;